import { Component, HostListener, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MemberService } from '../../core/services/member.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../core/services/feed.service';
import { AuthService } from '../../core/services/auth.service';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MediaService } from '../../core/services/media.service';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { EventService } from '../../core/services/event.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  breadcrumbs = [
    {
      title: ' My Profile ',
    },
  ];

  user = {
    name: 'William De Silva',
    email: 'Megan@info.com',
    mobileNo: '0770521051',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ' +
      'ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut\n' +
      '          aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore\n' +
      '          eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt\n' +
      '          mollit anim id est laborum.',
    position: 'Supreme Court Judge',
    residence: 'Supreme Court Kandy',
    workplace: 'Colombo',
  };
  member: {
    profilePicture: { url: string; mimeType: string } | null;
    name: string;
    description: string;
    regCode: string;
    _id: string;
    mobileNo: string;
    position: string;
    residence: string;
    workplace: string;
    grade: string;
    email: string;
    phoneNo: string;
    status: string;
  } = {
    _id: '',
    name: '',
    email: '',
    status: '',
    regCode: '',
    mobileNo: '',
    description: '',
    grade: '',
    position: '',
    residence: '',
    workplace: '',
    profilePicture: null,
    phoneNo: '',
  };

  feed = [
    {
      id: '',
      title: 'new show',
      content: 'test',
      media: { url: 'test', mimeType: '', filename: '' },
      createdAt: '2023-09-27T01:18:02.484Z',
    },
  ];
  files: File[] = [];
  isVisible = false;
  inVisibleModal2 = false;
  editPostForm!: FormGroup;
  postForm!: FormGroup;
  showFullText = false;
  showFullTextPost = false;
  mediaHeight = 300;
  wordCap = 250;
  avatarSize = 150;
  memberForm!: FormGroup;
  editPostId = '';
  isExpanded: boolean[] = [];
  acceptedEvents: any[] = [];
  rejectedEvents: any[] = [];
  selectedModal = 'post';

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private memberService: MemberService,
    private activatedRoute: ActivatedRoute,
    private feedService: FeedService,
    private authService: AuthService,
    private mediaService: MediaService,
    private router: Router,
    private eventsService: EventService,
  ) {
    this.setScreenSize(window.innerWidth);
  }

  ngOnInit(): void {
    this.member = this.authService.getLoggedInUser();
    this.initPostForm();
    this.initMemberForm();
    this.initEditPostForm();
    this.feedService.getFeedByMember(this.member._id).then((res) => {
      this.feed = res.docs;
      this.isExpanded = this.feed.map(() => false);
    });
    this.eventsService.getAcceptedEventsByUser(this.member._id).then((res) => { 
      this.acceptedEvents = res.docs;
    });
    this.eventsService.getRejectedEventsByUser(this.member._id).then((res) => {
      this.rejectedEvents = res.docs;
    });
  }

  toggleExpansion(index: number): void {
    this.isExpanded[index] = !this.isExpanded[index];
  }

  initPostForm(): void {
    this.postForm = this.formBuilder.group({
      title: [null, Validators.compose([Validators.required])],
      content: [null, Validators.compose([])],
    });
  }

  initEditPostForm(): void {
    this.editPostForm = this.formBuilder.group({
      title: ['', Validators.compose([Validators.required])],
      content: ['', Validators.compose([])],
    });
  }

  initMemberForm(): void {
    this.memberForm = this.formBuilder.group({
      _id: [this.member._id, Validators.required],
      mobileNo: [this.member.mobileNo, [Validators.required, this.phoneValidator]],
      phoneNo: [this.member.phoneNo, [Validators.required, this.phoneValidator]],
      workplace: [this.member.workplace, Validators.required],
      residence: [this.member.residence, Validators.required],
      description: [this.member.description, Validators.required],
    });
  }

  phoneValidator(control: AbstractControl): { [key: string]: any } | null {
    // Validate the phone number with an optional '+' sign
    const regex = /^(\+\d{1,3})?(\d{1,15})$/; // Adjust the regex as needed

    if (control.value && !regex.test(control.value)) {
      return { 'invalidPhone': true };
    }

    return null;
  }




  viewEvent(id: any): void {
    this.router.navigate(['/admin/single-event/', { id }]);
  }

  submitForm(): void {
    let formData = new FormData();
    const data = this.postForm.getRawValue();
    if (this.files[0]) {
      formData.append('file', this.files[0]);

      this.mediaService.addMedia(formData).then((res) => {
        formData = new FormData();
        formData.append('media', res.doc.id);
        formData.append('title', data.title);
        formData.append('content', data.content);
        formData.append('member', this.member._id);

        this.feedService.addPostByMember(formData).then(() => {
          this.ngOnInit();
          this.files = [];
        });
        this.handleCancel();
      });
    } else {
      formData = new FormData();
      formData.append('title', data.title);
      formData.append('content', data.content);
      formData.append('member', this.member._id);

      this.feedService.addPostByMember(formData).then(() => {
        this.ngOnInit();
        this.files = [];
      });
      this.handleCancel();
    }
  }

  onSelect(event: any) {
    if (this.files.length < 1) {
      this.files.push(...event.addedFiles);
    }
  }

  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  private setScreenSize(width: number): void {
    if (width < 768) {
      this.mediaHeight = 250;
      this.wordCap = 120;
      this.avatarSize = 70;
    } else {
      this.mediaHeight = 360;
      this.wordCap = 250;
      this.avatarSize = 150;
    }
  }

  showModal(): void {
    this.isVisible = true;
  }

  showModal2(): void {
    this.inVisibleModal2 = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.files = [];
    this.ngOnInit();
  }

  handleCancel2(): void {
    this.inVisibleModal2 = false;
    this.files = [];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.setScreenSize(event.target.innerWidth);
  }

  toggleText() {
    this.showFullText = !this.showFullText;
  }

  toggleTextPost() {
    this.showFullTextPost = !this.showFullTextPost;
  }

  formatDate(date: string): any {
    const originalDate = new Date(date);
    const formattedDate = this.datePipe.transform(
      originalDate,
      'h.mm a MMM d, y',
    );
    return formattedDate;
  }

  handleOkModal2(): void {
    if (this.files[0]) {
      const formData = new FormData();
      formData.append('file', this.files[0]);
      this.mediaService.addMedia(formData).then((res) => {
        this.member.profilePicture = res.doc;
        this.files = [];
      });
    }
    this.inVisibleModal2 = false;
  }

  editProfile(): void {
    this.setEditProfile();
    this.authService.setLoggedInUser(JSON.stringify(this.member));
    this.authService.updateMember(this.member).then(() => {
      this.files = [];
      this.ngOnInit();
    });
    this.isVisible = false;
  }

  setEditProfile(): void {
    this.member.mobileNo = this.memberForm.get('mobileNo')?.value;
    this.member.phoneNo = this.memberForm.get('phoneNo')?.value;
    this.member.workplace = this.memberForm.get('workplace')?.value;
    this.member.residence = this.memberForm.get('residence')?.value;
    this.member.description = this.memberForm.get('description')?.value;
  }

  editPostSubmit(): any {
    if (this.files[0]) {
      let formData = new FormData();
      formData.append('file', this.files[0]);

      this.mediaService.addMedia(formData).then((res) => {
        formData = new FormData();
        formData.append('media', res.doc.id);
        formData.append('title', this.editPostForm.value.title);
        formData.append('content', this.editPostForm.value.content);

        this.feedService.updatePost(formData, this.editPostId).then(() => {
          this.files = [];
          this.handleCancel();
          this.ngOnInit();
        });
      });
    } else {
      this.feedService
        .updatePost(this.editPostForm.getRawValue(), this.editPostId)
        .then(() => {
          this.handleCancel();
          this.ngOnInit();
        });
    }
  }

  editSetup(data: any) {
    const editPost = {
      title: data.title,
      content: data.content,
    };
    this.editPostId = data.id;
    this.editPostForm.setValue(editPost);
  }

  cancel(): void {

  }

  confirm(id: any): void {
    this.feedService.deletePost(id).then(() => {
      this.ngOnInit();
    });
  }

  removeProfileImage() {
    this.member.profilePicture = { url: '', mimeType: '' };
  }

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
    }
    else if (info.file.status === 'error') {
    }
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }
}
